import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Alert } from './alert';
import { CrudService } from '@mango/core';
import { Subject } from 'rxjs';
import * as signalR from "@aspnet/signalr";

@Injectable()
export class AlertService extends CrudService<Alert> {

    constructor(injector: Injector) {
        super(Alert, injector);

        this.setupHubConnection();
    }

    hubSubject: Subject<any> = new Subject<any>();

    setupHubConnection() {
        const connection = new signalR.HubConnectionBuilder().withUrl('/ws/alerts').build();

        connection.on('AlertBroadcast', ({ person }) => {

            this.hubSubject.next(person);
        });

        connection.onclose((err?: Error) => {
            if (err) {
                console.log(err);
            }
            else {
                this.hubSubject.complete();
            }
        });

        connection.start();
    }

}
